// src/creditManager.js

const STORAGE_KEY = 'erc_unlock_credits';
const FREE_UNLOCKS_KEY = 'erc_free_unlocks_used';

// 48-hour paid test: set to 0 to require payment for all unlocks, 2 for normal
const FREE_UNLOCK_LIMIT = 0;

// Initialize or get credits
export const getCredits = () => {
  try {
    const credits = localStorage.getItem(STORAGE_KEY);
    return credits ? parseInt(credits, 10) : 0;
  } catch (error) {
    console.error('Error reading credits:', error);
    return 0;
  }
};

// Set credits
export const setCredits = (amount) => {
  try {
    localStorage.setItem(STORAGE_KEY, amount.toString());
    // Dispatch custom event to notify components
    window.dispatchEvent(new CustomEvent('creditsChanged', { detail: amount }));
  } catch (error) {
    console.error('Error setting credits:', error);
  }
};

// Add credits
export const addCredits = (amount) => {
  const current = getCredits();
  setCredits(current + amount);
};

// Consume a credit
export const consumeCredit = () => {
  const current = getCredits();
  if (current > 0) {
    setCredits(current - 1);
    return true;
  }
  return false;
};

// Check if user has free unlocks remaining
export const getFreeUnlocksUsed = () => {
  try {
    const used = localStorage.getItem(FREE_UNLOCKS_KEY);
    return used ? parseInt(used, 10) : 0;
  } catch (error) {
    console.error('Error reading free unlocks:', error);
    return 0;
  }
};

// Consume a free unlock
export const consumeFreeUnlock = () => {
  const used = getFreeUnlocksUsed();
  if (used < FREE_UNLOCK_LIMIT) {
    try {
      localStorage.setItem(FREE_UNLOCKS_KEY, (used + 1).toString());
      window.dispatchEvent(new CustomEvent('creditsChanged'));
      return true;
    } catch (error) {
      console.error('Error using free unlock:', error);
      return false;
    }
  }
  return false;
};

// Check if user can unlock (either has credits or free unlocks)
export const canUnlock = () => {
  const freeUnlocksUsed = getFreeUnlocksUsed();
  const credits = getCredits();
  return freeUnlocksUsed < FREE_UNLOCK_LIMIT || credits > 0;
};

// Get remaining free unlocks
export const getRemainingFreeUnlocks = () => {
  const used = getFreeUnlocksUsed();
  return Math.max(0, FREE_UNLOCK_LIMIT - used);
};

// Process an unlock
export const processUnlock = () => {
  const freeUnlocksUsed = getFreeUnlocksUsed();
  
  if (freeUnlocksUsed < FREE_UNLOCK_LIMIT) {
    // Use free unlock
    return consumeFreeUnlock();
  } else {
    // Use paid credit
    return consumeCredit();
  }
};

// Handle Stripe payment success
export const handlePaymentSuccess = (packageId) => {
  const packages = {
    single: 1,
    pack5: 5,
    pack10: 10,
    pack25: 25
  };
  
  const creditsToAdd = packages[packageId] || 0;
  if (creditsToAdd > 0) {
    addCredits(creditsToAdd);
  }
};